export default __webpack_public_path__ + "static/media/FlexibleContent dropdown.aba7d5b4.jpg";